import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydTabs from '../../../../commonDesign/SydTabs'
import StepDetails from '../components/StepDetails'

const useStyles = makeStyles(() => ({
  empty: {
    padding: '14px 12px',
    color: 'var(--color-neutral-500)',
    fontSize: 13,
    fontStyle: 'italic',
    border: '1px dashed var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm, 4px)'
  },
  // Horizontally scroll the sub-tab strip so pipelines with many steps don't
  // silently truncate off the right edge of the drawer. mask-image / scrollbar
  // tweaks aren't expressible as opal utilities so they live in makeStyles.
  subTabs: {
    overflowX: 'auto',
    overflowY: 'hidden',
    maskImage: 'linear-gradient(to right, transparent 0, black 16px, black calc(100% - 16px), transparent 100%)',
    WebkitMaskImage: 'linear-gradient(to right, transparent 0, black 16px, black calc(100% - 16px), transparent 100%)',
    '& > div': { flexWrap: 'nowrap', width: 'max-content' },
    '&::-webkit-scrollbar': { height: 4 },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--color-neutral-300)',
      borderRadius: 2
    }
  }
}))

export default function StepsTab ({ steps }) {
  const classes = useStyles()
  const tabOptions = useMemo(() => {
    const opts = {}
    ;(steps || []).forEach((s, i) => {
      const truncatedOp = s.$op?.length > 22 ? `${s.$op.slice(0, 20)}…` : s.$op
      opts[`step-${i}`] = { label: `#${i} ${truncatedOp}`, order: i + 1 }
    })
    return opts
  }, [steps])

  if (!steps?.length) {
    return <div className={`${classes.empty} text-center`}>No steps in this pipeline.</div>
  }

  return (
    // Key by step count so switching to a pipeline with fewer steps remounts
    // the group instead of leaving the selected value pointing at a step that
    // no longer exists.
    <SydTabs.Group key={steps.length} tabOptions={tabOptions} defaultValue='step-0'>
      <div className={`${classes.subTabs} flex-shrink-0 mb-2`}>
        <SydTabs.MiniList />
      </div>
      {steps.map((s, i) => (
        <SydTabs.Tab key={i} value={`step-${i}`}>
          <StepDetails step={s} />
        </SydTabs.Tab>
      ))}
    </SydTabs.Group>
  )
}

StepsTab.propTypes = {
  steps: PropTypes.array
}
